import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IonButton } from '@ionic/angular/standalone';
import { SlipItemViewModel } from 'src/app/models/item.model';
import { ShowSlipEventPayload } from '../../models/event-payloads.model';
import { AttachmentsComponent } from '../attachments/attachments.component';
import { HubItemMessageComponent } from '../hub-item-message/hub-item-message.component';
import { ListItemHeaderComponent } from '../list-item-header/list-item-header.component';
import { PaymentPublisherComponent } from '../payment-publisher/payment-publisher.component';

@Component({
  selector: 'app-slip-item',
  templateUrl: './slip-item.component.html',
  styleUrls: ['./slip-item.component.scss'],
  imports: [
    ListItemHeaderComponent,
    HubItemMessageComponent,
    AttachmentsComponent,
    PaymentPublisherComponent,
    IonButton
  ]
})
export class SlipItemComponent {
  @Input() item: SlipItemViewModel;
  @Input() showPublisherLink: boolean;
  @Output() selectItem = new EventEmitter<string>();
  @Output() selectStudent = new EventEmitter<number>();
  @Output() selectPaymentRequests = new EventEmitter();
  @Output() openAttachment = new EventEmitter<string>();
  @Output() getThumb = new EventEmitter<string>();
  @Output() showSlip = new EventEmitter<ShowSlipEventPayload>();

  showSlipFunction(event): void {
    event.stopPropagation();
    this.showSlip.emit({
      studentId: this.item.student.id,
      schoolId: this.item.schoolId,
      slipId: this.item.categoryId
    });
  }
}
